var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"search",class:{ open: _vm.isOpen }},[_c('input',{staticClass:"search-box",attrs:{"type":"search"},domProps:{"value":_vm.url},on:{"input":_vm.hoge}}),_vm._v(" "),_c('span',{staticClass:"search-button",on:{"click":function($event){return _vm.clicked()}}},[_c('span',{staticClass:"search-icon"})])]),_vm._v(" "),(_vm.show)?_c('div',[_c('p',[_vm._v("\n    "+_vm._s(_vm.url)+"\n  ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/YoutubePlayer.vue?vue&type=template&id=2ea8debe&scoped=true&
// module id = null
// module chunks = 